import { Divider, View, VStack } from "@gluestack-ui/themed";
import { NewTransactionReceiptController } from "./controller";
import { TransactionInfoSection } from "@repo/core/components/receipt/sections/TransactionInfoSection";
import { storeInfoMock } from "./mocks";
import { StoreInfoSection } from "@repo/core/components/receipt/sections/StoreInfoSection";
import { ClientInfoSection } from "@repo/core/components/receipt/sections/ClientInfoSection";
import { Icon } from "@repo/core/components/core/Icon";
import { Text } from "@repo/core/components/core/Text";
import { numberToBrl } from "@repo/core/utils/currency.utils";
import { ReceiptFooterSection } from "@repo/core/components/receipt/sections/ReceiptFooterSection";
import Scaffolds from "@repo/core/components/layout/Scaffolds";
import { ShareButton } from "@repo/core/components/core/ShareButton";

const NewTransactionReceipt = () => {
  const {
    isMobile,
    handleGoToSales,
    clientInfo,
    transactionInfo,
    title,
    selectedStore,
    viewRef,
    handleCaptureAndGeneratePDF,
    isLoading
  } = NewTransactionReceiptController();
  return (
    <Scaffolds.Root
      title={title}
      onBackPress={handleGoToSales}
      rightIcon="times"
      rightIconSize={20}
      rightWebLabel="Fechar"
      onPressRightIcon={handleGoToSales}
    >
      <Scaffolds.Form
        footerContent={
          <VStack
            pt={isMobile ? "$4" : "$12"}
            px={isMobile ? "$6" : "$0"}
            pb="$4"
            justifyContent="flex-end"
          >
            <ShareButton
              onPress={handleCaptureAndGeneratePDF}
              isLoading={isLoading}
            />
          </VStack>
        }
      >
        <View flex={1} ref={viewRef} collapsable={false}>
          <VStack alignItems="center" gap={8} p="$4">
            <Icon
              name="receipt"
              color="$primary500"
              size={46}
              variant="solid"
            />
            <Text fontSize="$2xl" fontWeight={600}>
              {numberToBrl(transactionInfo?.totalValue || 0)}
            </Text>
            <Text>{selectedStore?.descrLoja}</Text>
          </VStack>
          <Divider />
          <VStack px="$6">
            <TransactionInfoSection {...transactionInfo} />
          </VStack>
          <Divider />
          <VStack px="$6">
            <StoreInfoSection {...storeInfoMock} />
          </VStack>
          <Divider />
          <VStack px="$6">
            <ClientInfoSection {...clientInfo} />
          </VStack>
          <ReceiptFooterSection transactionId="5661214er5f-25df8-982d-h87u-b2y6e3a6c4f88b" />
        </View>
      </Scaffolds.Form>
    </Scaffolds.Root>
  );
};
export default NewTransactionReceipt;
